import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-nidhi',
  templateUrl: './nidhi.component.html',
  styleUrls: ['./nidhi.component.scss']
})
export class NidhiComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getNidhi();
  }

}
